import {
	Component,
	CUSTOM_ELEMENTS_SCHEMA,
	ElementRef,
	EventEmitter,
	HostBinding,
	Input,
	OnInit,
	Output
} from '@angular/core';
import type { CheckedEvent } from 'lua-web-components/dist/types/shared/types/checkbox.model';

// Temporary: Define CheckboxEvents here due to unresolved import issues, even though they exist in lua-web-components
export const CheckboxEvents = {
	CHECKED: 'luds-checkbox:checked'
};

@Component({
	selector: 'angie-luds-checkbox',
	template: `
		<luds-checkbox
			[checked]="checked"
			[disabled]="disabled"
			[indeterminate]="indeterminate"
			[label]="label"
			[checkboxAriaLabel]="checkboxAriaLabel"
			[name]="name"
			[id]="id"
			[useHtmlLabel]="useHtmlLabel"
			[value]="value"></luds-checkbox>
	`,
	standalone: true,
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LudsCheckboxComponent implements OnInit {
	/**
	 *
	 * This styling ensures that the wrapper element maintains the same size as the child checkbox element.
	 * The actual checkbox size is defined within the <luds-checkbox> component itself;
	 * the wrapper simply sets its own display and height styles to match, ensuring consistent layout and alignment.
	 */
	@HostBinding('style.display') display = 'block';
	@HostBinding('style.height') checkboxHeight = '20px';
	@Input() checked: boolean;
	@Input() disabled: boolean;
	@Input() indeterminate: boolean;
	@Input() label: string;
	@Input() checkboxAriaLabel: string;
	@Input() name: string;
	@Input() id: string;
	@Input() useHtmlLabel: boolean;
	@Input() value: string;

	@Output() checkedEvent = new EventEmitter<CustomEvent<CheckedEvent>>();

	constructor(private el: ElementRef) {}

	ngOnInit(): void {
		const checkbox = this.el.nativeElement.querySelector('luds-checkbox');
		checkbox.addEventListener(CheckboxEvents.CHECKED, (event: CustomEvent<CheckedEvent>) => {
			this.checkedEvent.emit(event);
		});
	}
}
